import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import googlePlay from "../../Assets/google_play.svg";
import appStore from "../../Assets/app_store.svg";
import instagramIcon from "../../Assets/instagram.svg";
import facebookIcon from "../../Assets/facebook.svg";
import twitterIcon from "../../Assets/twitter.svg";
import linkedinIcon from "../../Assets/linkedin.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__seo">
        <p>
          Fusshn is a platform to buy or sell event tickets effortlessly? Fusshn
          has got you covered! Whether it’s concerts, sports events, shows, or
          exclusive gatherings, Fusshn connects ticket buyers and sellers in a
          seamless, secure, and hassle-free way. Book events in Mumbai | Book
          events in Delhi | Book events in Chennai | Book events in Bengaluru |
          Book events in Hyderabad | Book events in Pune | Book events in
          Ahmedabad | Book events in Kolkata | Book music events in Mumbai |
          Book music events in Delhi | Book music events in Chennai | Book music
          events in Bengaluru | Book music events in Hyderabad | Book music
          events in Pune | Book music events in Ahmedabad | Book music events in
          Kolkata | Book comedy events in Mumbai | Book comedy events in Delhi |
          Book comedy events in Chennai | Book comedy events in Bengaluru | Book
          comedy events in Hyderabad | Book comedy events in Pune | Book comedy
          events in Ahmedabad | Book comedy events in Kolkata.
          <br />
          <br />
          Book events in Mumbai | Book events in Delhi | Book events in Chennai
          | Book events in Bengaluru | Book events in Hyderabad | Book events in
          Pune | Book events in Ahmedabad | Book events in Kolkata | Book music
          events in Mumbai | Book music events in Delhi | Book music events in
          Chennai | Book music events in Bengaluru | Book music events in
          Hyderabad | Book music events in Pune | Book music events in Ahmedabad
          | Book music events in Kolkata | Book comedy events in Mumbai | Book
          comedy events in Delhi | Book comedy events in Chennai | Book comedy
          events in Bengaluru | Book comedy events in Hyderabad | Book comedy
          events in Pune | Book comedy events in Ahmedabad | Book comedy events
          in Kolkata.
        </p>
      </div>
      <div className="footer__main">
        <div className="footer__column brand">
          <h2>FUSSHN</h2>
          <p>
            Buy, sell, and discover tickets effortlessly! From concerts to
            sports and theater, Fusshn makes event ticketing seamless, secure,
            and fast. Browse, compare, and grab the best deals.
          </p>
          <div className="footer__apps">
            <a
              href="https://play.google.com/store/apps/details?id=com.fusshn.fusshncustomer&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googlePlay} alt="Google Play" />
            </a>
            <a href="https://apps.apple.com/in/app/fusshn-ticket-to-convenience/id6745167053"
              target="_blank"
              rel="noopener noreferrer">
              <img src={appStore} alt="App Store" />
            </a>
          </div>
        </div>

        <div className="footer__column">
          <h4>Company</h4>
          <ul>
            <li>Event</li>
            <li>
              <Link to="/setup-account">
                List your Event
              </Link>
            </li>
            <li>Our Team</li>
            <li>Careers</li>
            <li>
              <Link to="/Contact_Us">
                Contact us
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer__column">
          <h4>Resource</h4>
          <ul>
            <li>
              {" "}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="/Terms & Conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Condition
              </a>
            </li>
            <li>Customer Support</li>
            <li>Purchase & Refund</li>
          </ul>
        </div>

        <div className="footer__column">
          <h4>Social Links</h4>
          <div className="footer__social">
            <a
              href="https://www.instagram.com/fusshn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={instagramIcon}
                alt="Instagram"
                className="social-icon"
              />
            </a>
            <a
              href="https://www.facebook.com/share/1APxatEANk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebookIcon} alt="Facebook" className="social-icon" />
            </a>
            <a
              href="https://x.com/fusshn_in?t=UA3O3ZiFkAg8WseWHa85Vg&s=08"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={twitterIcon} alt="Twitter" className="social-icon" />
            </a>
            <a
              href="https://www.linkedin.com/company/fusshn/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
            </a>
          </div>
        </div>
      </div>

      <hr className="footer__divider" />
      <div className="footer__bottom">
        © 2025 Copyright by Fusshn. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
